import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILeaderboardLeague, ILeaderboardTable, INotifyLeaderboardLeagueData } from "./leaderboard.t";

export interface ILeaderboardState {
    onboarding: {
        isJoin: boolean
        error?: string | null;
    },
    leagues: ILeaderboardLeague[],
    leaderboardGroup: {
        data: ILeaderboardTable | null
        isLoading: boolean
        error?: string | null;
    },
    notifyLeaderboardLeague: INotifyLeaderboardLeagueData | null
}

const initialState: ILeaderboardState = {
    onboarding: {
        isJoin: false,
        error: null,
    },
    leagues: [],
    leaderboardGroup: {
        data: null,
        isLoading: true,
        error: null,
    },
    notifyLeaderboardLeague: null
}

export const leaderboardSlice = createSlice({
    name: 'leaderboard',
    initialState,
    reducers: {
        completeLeaderboardOnboardingAction: (state) => {
            state.onboarding.error = null;
        },
        completeLeaderboardOnboardingSuccess: (state) => {
            state.onboarding.isJoin = true;
        },
        completeLeaderboardOnboardingError: (state, action) => {
            state.onboarding.error = action.payload;
        },
        getLeaderboardGroupByCurrentUserAction: (state) => {
            state.leaderboardGroup.isLoading = true;
            state.leaderboardGroup.error = null;
        },
        getLeaderboardGroupByCurrentUserSuccess: (state, action: PayloadAction<ILeaderboardTable>) => {
            state.leaderboardGroup.isLoading = false;
            state.leaderboardGroup.data = action.payload;
        },
        getLeaderboardGroupByCurrentUserError: (state, action) => {
            state.leaderboardGroup.isLoading = false;
            state.leaderboardGroup.error = action.payload;
        },
        getLeaderboardLeaguesAction: () => {},
        getLeaderboardLeaguesSuccess: (state, action: PayloadAction<ILeaderboardLeague[]>) => {
            state.leagues = action.payload;
        },
        getLeaderboardLeaguesError: (state, action) => {},
        setLeaderboardNotifyLeague: (state, action) => {
            state.notifyLeaderboardLeague = action.payload;
        }
    },
})

export default leaderboardSlice.reducer;